/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import useFsService from "../../../services/fsService";
import { NavLink } from "react-router-dom";
import FaceRank from "../result/faceRank/faceRank";
import Spinner from "../../spinner/spinner";
import ErrorScreen from "../../error/error";
import { gsap } from "gsap";
import allImages from "../../../utils/images";
import { useLanguageRegion } from "../../providers/LanguageRegionContext";

const ProfileTests = ({ id }) => {
  const { t } = useTranslation();
  const { getTestsList, sendReminder, loading, error, errorText, clearError } =
    useFsService();
  const [testsData, setTestsData] = useState([]);
  const [remindData, setRemindData] = useState("0");
  const listRef = useRef(null);
  const { lang, region } = useLanguageRegion();

  // Language/region → locale mapping for dates
  const localeMap = {
    ru: 'ru-RU',
    blr: 'ru-RU',
    kk: 'kk-KZ',
    en: 'en-US',
    es: 'es-ES',
    mex: 'es-MX',
    fr: 'fr-FR',
    it: 'it-IT',
    cs: 'cs-CZ',
    sk: 'sk-SK',
    sl: 'sk-SK',
    ro: 'ro-RO',
    tr: 'tr-TR',
    uz: 'uz-UZ',
    vi: 'vi-VN',
    ka: 'ka-GE',
    he: 'he-IL',
    zh: 'zh-CN',
  };
  const dateLocale =
    localeMap[lang?.code] || localeMap[region?.code] || 'ru-RU';

  useEffect(() => {
    clearError();
    const fetchTests = async () => {
      try {
        const res = await getTestsList(id);
        if (res.data.result) {
          const dataArray = Object.values(res.data.data.tests);
          dataArray.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setTestsData(dataArray);
          setRemindData(res.data.data.reminder);
        }
      } catch (e) {}
    };

    fetchTests();
  }, [id]);

  useEffect(() => {
    if (testsData.length > 0) {
      gsap.fromTo(
        listRef.current.children,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1.6,
          stagger: 0.3,
          ease: "power3.out",
        }
      );
    }
  }, [testsData]);

  const activateReminder = async () => {
    try {
      const res = await sendReminder();
      if (res?.data?.result && typeof res.data.reminder !== "undefined") {
        setRemindData(res.data.reminder);
      }
    } catch (error) {
      console.error("Ошибка при переключении напоминания", error);
    }
  };

  const spinner = loading ? <Spinner /> : null;
  const errorScreen = error ? <ErrorScreen errorText={errorText} /> : null;
  const content =
    !loading && !error ? (
      <ul className="profile__tests" ref={listRef}>
        {!id && (
          <li className="profile__newtest">
            <p>{t("profile.tests.new", "Начать новый тест")}</p>
            <picture>
              <img
                src={allImages.Remind}
                srcSet={allImages.Remind}
                width={103}
                height={102}
                alt="Напоминание"
              />
            </picture>
            <button type="button" onClick={activateReminder}>
              {Number(remindData) > 0
                ? t("profile.tests.remindRemove", "Убрать напоминание")
                : t("profile.tests.remind", "Поставить напоминание")}
              <allImages.Bell />
            </button>
            {Number(remindData) >= 1 && (
              <div>
                {t(
                  "profile.tests.daysLeft",
                  "Напоминание сработает через(дней):"
                )}{" "}
                {Number(remindData)}
              </div>
            )}
            <NavLink to="/photo">
              <span>{t("profile.tests.start", "Начать новый тест")}</span>
            </NavLink>
          </li>
        )}
        {testsData.map((item) => {
          const date = new Date(item.created_at);
          const formattedDate = date.toLocaleString(dateLocale, {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });

          return (
            <li key={item.id}>
              <NavLink to={`result/${item.id}`}>
                <p>{formattedDate}</p>
                <FaceRank resultData={item} />
                <span>{t("profile.tests.next", "Далее")}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    ) : null;

  return (
    <>
      <h1>
        {testsData.length > 0 && testsData[0]?.nickname ? (
          <>
            {t("profile.tests.complete", "Выполненные скрининги пользователя:")}{" "}
            {testsData[0].nickname}
          </>
        ) : (
          t("profile.tests.empty", "Пройденные тесты отсутствуют")
        )}
      </h1>

      {spinner}
      {errorScreen}
      {content}
    </>
  );
};

export default ProfileTests;
